export const ACTIVITY_LEVEL_VALUE = {
  MINIMUM: 'minimum',
  EASY: 'easy',
  MEDIUM: 'medium',
  HARD: 'hard',
} as const;

export type TActivityLevelValue = (typeof ACTIVITY_LEVEL_VALUE)[keyof typeof ACTIVITY_LEVEL_VALUE];

export type TActivityLevel = Array<TActivityLevelValue>;
